module.exports = __webpack_public_path__ + "img/la.75921adc.svg";